const getUserCountry = () => JSON.parse(Buffer.from(localStorage.getItem('accessToken').split('.')[1], 'base64').toString('utf-8')).nike_country;

export default getUserCountry;
